import { Box } from "@material-ui/core";
import { split } from "lodash";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

interface Props {
  quoteTitle: string | null;
}

export const QuoteDetailTitle = ({ quoteTitle }: Props) => {
  const { isMoreThanMd } = useBreakpoint();
  if (quoteTitle === null) {
    return null;
  }
  const titles = split(quoteTitle, "&");
  const mainTitle = titles[0];
  const secondTitle = titles.slice(1).join("&");
  return (
    <>
      <Box fontSize={isMoreThanMd ? "26px" : "20px"} fontWeight={300} color="#160037">
        {mainTitle} {titles.length > 1 ? " &" : ""}
      </Box>
      <Box fontSize={isMoreThanMd ? "26px" : "20px"} fontWeight={300} color="#160037">
        {secondTitle}
      </Box>
    </>
  );
};
